export enum RESELLER_CONSOLE {
    AUTO_SYNC_HELPER = 'Force login for all users from this source, using their source credentials.',
    AUTO_SYNC_LABEL = 'Automatic login',
    CELL = 'Cell',
    CUSTOMER = 'Customer',
    CUSTOMER_EXTERNAL_DIRECTORY = 'External directory url',
    CUSTOMER_ID = 'Customer id',
    CUSTOMER_IS_RESELLER = 'This customer is a reseller',
    CUSTOMER_LICENSE_EXPIRATION_DATE = 'License expiration date',
    CUSTOMER_LICENSE_NUMBER = 'Licenses number',
    LICENSE = 'License',
    CUSTOMER_NAME = 'Customer name',
    REGISTRATION_LINK_GOOGLE = 'G Suite',
    CLASSIC = 'Classic',
    SETTING_NAME = 'Setting name',
    INSTANCE_SETTINGS = 'Instances settings',
    INSTANCE_THEMES = 'Instances themes',
    THEME_NAME = 'Theme name',
    INSTANCES_OVERRIDES = 'Instances overrides',
    OVERRIDE_NAME = 'Override name',
    PROVIDERS = 'Providers',
    RESELLER = 'Reseller',
    CUSTOMER_NB_USERS = 'Users number',
    CUSTOMER_SAVED = 'Customer saved',
    CUSTOMER_SETTINGS = 'Customer settings',
    CUSTOMER_SLUG = 'Organization name used in URL',
    CUSTOMER_TRUSTED_TESTER = 'Trusted tester',
    CUSTOMER_TRUSTED_TESTER_HELPER = "Trusted testers will gain access to new features before they're made public to all customers.",
    EXTERNAL = 'External',
    FEATURE_PACKAGES = 'Feature packages',
    GOOGLE_CLOUD_IDENTITY_SOURCE_ID = 'Google Cloud Identity Source ID',
    LICENSE_EXPIRED = 'License is expired',
    LICENSE_OVER_QUOTA = 'Maximum number of users reached',
    RESELLER_CONSOLE = 'Reseller console',
    NO_DESCRIPTION_AVAILABLE = 'No description available.',
}
